import { createFileRoute } from '@tanstack/react-router';
import { MemberEndorsementPage } from '@/pages/chain/endorsement/MemberEndorsementPage';

export const Route = createFileRoute('/_authenticated/_app/chain/my-endorsement')({
	component: MemberEndorsementPage,
});
